<template>
  <div class="sc-webview">
    <iframe 
        v-if="loaded"
        :src="chat.webviewUrl"
        type="text/html"
        frameborder="0"
    ></iframe>
    <div class="sc-webview--footer" :style="{background: colors.header.bg, color: colors.header.text}">
        <h3 class="sc-webview--button" @click="close()">
           <img :src="icons.backIcon" :alt="$t('Back')" width="16px" height="16px"/>
            {{$t('Back')}}
        </h3>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Webview',
  inject: {
    colors: {
      type: Object
    },
    widget: {
      type: Object
    },
    icons: {
      type: Object
    },
    chat: {
      type: Object
    }
  },
  props: {
    item: Object,
    parent: Object
  },
  data() {
    return {
      loaded: false
    }
  },
  mounted() {
    this.loaded = true;
  },
  methods: {
    close() {
        this.chat.webviewUrl = ''
    }
  }
}
</script>
<style scoped>
.sc-webview {
    border: 0!important;
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
}
.sc-webview iframe {
    width: 100%;
    height: calc(100% - 35px);
}
.sc-webview--footer {
    width: 100%;
    height: 35px;
    text-align: center;
    display:table;
}
.sc-webview--button {
    cursor: pointer;
    display:table-cell;
    vertical-align:middle;
    margin: 0;
    padding: 0;
}
.sc-webview--button img {
    vertical-align: middle;
}
</style>
